// extracted by mini-css-extract-plugin
export default {"modal":"fda-z","modalContent":"gda-z","footer":"hda-z","cancelBtn":"ida-z","disabled":"jda-z","formWrapper":"kda-z","fade":"lda-z","fade-in":"mda-z","iframe":"nda-z"};